import axios from "axios";

// Resolve the API base at runtime so we never hit a cross-origin redirect
// (e.g., vbscooter.in -> www.vbscooter.in) which breaks browser fetch.
// In a browser, always use the page's own origin — Emergent routes /api on
// the same domain as the frontend in both preview and production.
const ENV_URL = process.env.REACT_APP_BACKEND_URL || "";

function resolveBaseURL() {
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return window.location.origin;
  }
  return ENV_URL;
}

const BASE = resolveBaseURL();
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
});

export async function getCompany() {
  const { data } = await api.get("/company");
  return data;
}

export async function getModels() {
  const { data } = await api.get("/models");
  return data;
}

export async function getModel(slug) {
  const { data } = await api.get(`/models/${slug}`);
  return data;
}

export function formatPriceINR(value) {
  if (value == null) return "";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(value);
}
